<template>
  <div class="device-view">
    <div class="sticky-element ">
      <FaultStickyTable class="panel" />
    </div>
    <b-row>
      <b-col md="3" class="guard-data">
        <template v-if="device">
          <ShowAttribute v-for="(value, key) in device" :key="key" :value="value" :label="key" />
          <GrabWaveform />
        </template>
        <template v-else> <NoData /> </template>
      </b-col>
      <b-col md="9" class="guard-events">
        <b-row>
          <b-col xl="9">
            <FaultEventsList :min-date="formatMinDate(guardCreatedAt)" />
          </b-col>
          <b-col xl="3">
            <FaultData />
          </b-col>
        </b-row>
        <b-row class="mt-3 mr-xl-0">
          <FaultEventsWaveforms :min-date="formatMinDate(guardCreatedAt)" />
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MomentTimezone from 'moment-timezone';
import { FORMAT_YMD_TIMEZONE } from '@/components/shared/date-format';
import NoData from '@/components/shared/no-data';
import ShowAttribute from '@/components/device/show-attribute';
import FaultMixins from '@/components/mixins/fault/fault-mixin';
import FaultEventsList from '@/components/device/guard-1000/fault-events';
import FaultData from '@/components/device/guard-1000/fault-events-data';
import FaultEventsWaveforms from '@/components/device/guard-1000/fault-events-waveforms';
import FaultStickyTable from '@/components/device/guard-1000/fault-sticky-table';
import GrabWaveform from '@/components/device/guard-1000/fault-grab-waveform';

const formatToDate = date => MomentTimezone(date).format(FORMAT_YMD_TIMEZONE);
const deviceName = 'GUARD1000';

export default {
  name: 'Guard1000FaultEvent',
  components: {
    FaultEventsList,
    FaultData,
    FaultEventsWaveforms,
    FaultStickyTable,
    NoData,
    ShowAttribute,
    GrabWaveform
  },
  mixins: [FaultMixins],
  computed: mapState({
    guardCreatedAt: state => state.guard1000.data.createdAt,
    device: state => {
      const { name, externalGuardId, createdAt, updatedAt } = state.guard1000.data;

      return {
        type: deviceName,
        name,
        externalGuardId,
        createdAt: formatToDate(createdAt),
        updatedAt: formatToDate(updatedAt)
      };
    }
  })
};
</script>
